module.exports = __webpack_public_path__ + "img/avatar1.a0d943e6.jpg";